import { AGWASuiteApiClientBase, ApiResponse } from '../agwasuite-api';
import type {
  NotificationTopicRequest,
  NotificationTopicResult,
  NotificationTopicsBatchRequest,
  NotificationTopicsBatchResult,
} from '../agwa-api-model';

// Centralized Notification API client for topic management endpoints.
// Uses generated model types (no local DTO definitions).

const BASE_PATH = '/api/notification';

export class NotificationApi extends AGWASuiteApiClientBase {
  async manageTopic(
    req: NotificationTopicRequest
  ): Promise<ApiResponse<NotificationTopicResult>> {
    return this.post<NotificationTopicRequest, NotificationTopicResult>(
      `${BASE_PATH}/topic`,
      req
    );
  }
  async manageTopics(
    req: NotificationTopicsBatchRequest
  ): Promise<ApiResponse<NotificationTopicsBatchResult>> {
    return this.post<
      NotificationTopicsBatchRequest,
      NotificationTopicsBatchResult
    >(`${BASE_PATH}/topics`, req);
  }
}

export function createNotificationApi() {
  // Caller should use ApiFactory.authenticated(NotificationApi) ideally.
  return new NotificationApi();
}
